import { Navigate, useParams } from "react-router-dom";
import DiscoverPage from "@/pages/discover/DiscoverPage";
import { getSectorBySlug } from "./sectorCatalog";

export default function SectorDiscoverPage() {
  const { slug } = useParams<{ slug: string }>();
  const sector = getSectorBySlug(slug);

  if (!sector) {
    return <Navigate to="/" replace />;
  }

  return <DiscoverPage initialKeyword={sector.searchKeyword} />;
}
